import { useContext } from 'react';
import UserContext from '../General/UserContext';

export default function SearchButton() {
  const { setShowCMDK } = useContext(UserContext);
  return (
    <button
      onClick={() => setShowCMDK(true)}
      className="tw-group tw-relative tw-flex focus:tw-outline-none twbtn tw-w-full"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="tw-absolute tw-inset-y-0 tw-left-4 tw-z-10 tw-my-auto tw-h-4 tw-w-4 tw-text-gray-500"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
        />
      </svg>

      <div className="tw-w-full tw-rounded-xl tw-border-gray-200 tw-bg-white dark:tw-bg-gray-900 tw-p-3 tw-pl-12 tw-text-left tw-text-gray-500 tw-transition-colors group-active:tw-bg-gray-50 dark:group-active:tw-bg-gray-800">
        Search for help articles...
      </div>
      <span className="tw-absolute tw-inset-y-0 tw-right-4 tw-my-auto tw-h-5 tw-text-sm tw-text-gray-400">
        ⌘K
      </span>
    </button>
  );
}
